import React from 'react';
import parse from 'html-react-parser';

export default function OptionFootnote({footnote}) {
  return footnote && (<div className="app-option-footnote">{parse(footnote)}</div>)
};
